<script lang="ts" setup>
import { AppButton, AppTextField } from '#core/components';
import { computed } from 'vue';

const emits = defineEmits<{
  (e: 'next', username: string): void;
}>();

const { form, serverError, loadingForgotPassword, handleForgotPassword, getErrors } = useForgotPassword();

function forgotPassword() {
  handleForgotPassword(function () {
    emits('next', form.value.username);
  });
}

const errors = computed(() => {
  return getErrors({ username: serverError.value?.data?.errors.username });
});
</script>

<template>
  <v-form @submit.prevent="forgotPassword" class="d-flex flex-column gap-xl">
    <AppTextField
      v-model="form.username"
      data-testid="email"
      label="Email Address"
      :error-messages="errors.username"
      :disabled="loadingForgotPassword"
      autofocus
      hideDetails="auto"
      data-cy="input-email"
    >
    </AppTextField>

    <AppButton block :loading="loadingForgotPassword" type="submit" data-testid="submit"> Continue </AppButton>
  </v-form>
</template>
